// Défilement doux vers une section de la landing (ancre par id).
//
// Les sections sous la ligne de flottaison (dont les tarifs, #tarifs) sont chargées
// en lazy : si la cible n'est pas encore montée au moment du clic, on réessaie
// brièvement le temps que le chunk arrive, puis on défile. Sans persistance, sans
// dépendance.
export function scrollToSection(id) {
    if (typeof document === "undefined" || !id) return;
    const go = (el) => el.scrollIntoView({ behavior: "smooth", block: "start" });

    const now = document.getElementById(id);
    if (now) {
        go(now);
        return;
    }
    // Section lazy pas encore dans le DOM : on l'attend (~3 s max).
    let tries = 0;
    const timer = setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
            clearInterval(timer);
            go(el);
        } else if (++tries >= 30) {
            clearInterval(timer);
        }
    }, 100);
}
